import React, { lazy } from 'react';
import { CalendarIcon, FileTextIcon, CheckCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { Divider } from './Divider';
const IMG = 'https://cdn.magicpatterns.com/uploads/kh8kGEHNiFrx5XwSLvkrqs/mujer_con_celular.webp';
const features = [{
  icon: CalendarIcon,
  title: '30 días de programa guiado',
  desc: 'Un plan claro, día por día, que te toma de la mano sin abrumarte.'
}, {
  icon: FileTextIcon,
  title: 'Guía práctica cada día',
  desc: 'Contenido claro para consultar y aplicar a tu propio ritmo.'
}, {
  icon: CheckCircleIcon,
  title: 'Checklist de progreso diario',
  desc: 'Marca tus avances y siente cómo tu cuerpo vuelve a responder.'
}];
export function WhatIsSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-159" data-mp="35avbd3x4gswn">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-160" data-mp="35ad5rgokl2c2">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-161" data-mp="3a9psm1ffy9en">
          <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-162" data-mp="3a84zmg8ryyiw">
            Tu coach hormonal en la palma de tu mano
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-tinta/70" data-id="element-163" data-mp="gf6vd21954q3">
            Una mini app cálida y sencilla que te acompaña cada día. Sin citas,
            sin complicaciones y sin tecnicismos: solo pasos simples que sí
            puedes seguir desde tu celular.
          </p>
        </Reveal>

        <div className="mt-12 grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-164" data-mp="1hwlfx49c6wh">
          <Reveal data-id="element-165" data-mp="3sv0t19a2h5hw">
            <div className="overflow-hidden rounded-3xl shadow-xl shadow-tinta/10" data-id="element-166" data-mp="3suhgk836r9b9">
              <img src={IMG} alt="Mujer sonriente usando la app Cambio Hormonal desde una cama acogedora con luz cálida" className="h-full max-h-[560px] w-full object-cover" loading="lazy" data-id="element-167" data-mp="3ot5s45w1su4n" />
            </div>
          </Reveal>

          <div className="grid gap-5" data-id="element-168" data-mp="39xprtj4vk1zt">
            {features.map((f, i) => <Reveal key={f.title} delay={i * 0.1} data-id="element-169" data-mp="308j6bm3hyu8a" data-mpi={i}>
                <div className="flex gap-5 rounded-2xl border border-nude/60 bg-crema/50 p-5 sm:p-6" data-id="element-170" data-mp="307r966u94ofw">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-rosa/15 text-rosa-dark" data-id="element-171" data-mp="3562i8fcq2ux2">
                    <f.icon className="h-6 w-6" strokeWidth={1.6} data-id="element-172" data-mp="2v9pqhn0qmr4y" />
                  </span>
                  <div data-id="element-173" data-mp="3izk1s05es7n3">
                    <h3 className="font-serif text-xl font-semibold text-tinta" data-id="element-174" data-mp="3iz20gp3w338b">
                      {f.title}
                    </h3>
                    <p className="mt-1 text-tinta/70" data-id="element-175" data-mp="3ny50fv50ij9f">{f.desc}</p>
                  </div>
                </div>
              </Reveal>)}
          </div>
        </div>

        <div className="mt-16" data-id="element-176" data-mp="3e7satoicbzwf">
          <Divider data-id="element-177" data-mp="3e70luwj910f4" />
        </div>
      </div>
    </section>;
}